import React from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { isEmpty } from 'lodash';
import css from './CheckBackSoon.scss';
import { SFVirtualCheckInDaySchedule } from 'utils/types';
import moment from "moment";

/**
 * Generates the display of the days and hours for which a kiosk is open and available virtually.
 *
 * @param {SFVirtualCheckInDaySchedule[]} virtualCheckInSchedule - the days and times to display
 * @returns {JSX.Element} - an element containing all days and times for the provided kiosk
 */
const CheckInSchedule = ({virtualCheckInSchedule}) => {
    const formatSlotTime = (time) => moment(time, "HH:mm").format("h:mm a")

    const renderTimesForDay = (daySchedule) =>
        daySchedule.timeSlots !== null && daySchedule.timeSlots.map((timeSlot, idx) =>
            <div className={css['time-slot']} key={`timeSlot-${idx}`}>
                {formatSlotTime(timeSlot.openTime)} - {formatSlotTime(timeSlot.closeTime)}
            </div>
        );

    const renderDayList = () => {
        if (isEmpty(virtualCheckInSchedule)) return <div>Schedule currently unavailable for display.</div>;
        return virtualCheckInSchedule.map((daySchedule, idx) =>
            <div className={css['schedule-day']} key={`day-${idx}`}>
                <div className={css['day-of-week']}>{daySchedule.dayOfWeek.substring(0, 2)}</div>
                <div className={css['time-slots-for-day']}>{renderTimesForDay(daySchedule)}</div>
            </div>
        );
    }

    return (
        <div className={css['schedule-details']}>{renderDayList()}</div>
    );
}

CheckInSchedule.propTypes = {
    virtualCheckInSchedule: PropTypes.arrayOf(SFVirtualCheckInDaySchedule).isRequired
}

export default hot(CheckInSchedule);
